var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwipePrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15c0-3.784-2.359-10-14.42-10.774V.694c0-.28.143-.534-.124-.641C7.367.018 7.432 0 7.34 0c-.186 0-.29.07-.426.203L.189 6.778c-.279.27-.236.71.043.982l6.763 6.574c.204.2.195.258.462.15.266-.107.123-.36.123-.64V10.43C11.6 10.545 21.22 11.462 22 15",
    fill: "#5D5D5D"
  })));
}

export default SvgSwipePrevious;